import styled from "@emotion/styled";
import { Button } from "src/atoms/Button";

export const SocialIconButton = styled(Button)`
  position: static;

  > span:first-of-type {
    position: static;
    left: 16px;
  }

  span {
    width: fit-content;
    text-transform: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    position: relative;

    > span:first-of-type {
      position: absolute;
    }
  }
`;
